import { Delete } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import { showError, showToast } from '../../constants/toasts';
import MainContainer from '../../layout/MainContainer';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import { useDeleteNewsletterMutation, useGetNewsletterQuery } from '../../service/cms';
import { isValidInput } from '../../utils/validations';

const NewsLetterEmail = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>('');
  const [deleteById] = useDeleteNewsletterMutation();

  const onPageChange = (e: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const { data, isSuccess, isLoading } = useGetNewsletterQuery({
    page: page,
    limit: 10,
    search: debouncedSearchTerm,
  });

  const handleDelete = async () => {
    try {
      const response = await deleteById({
        id: selectedId,
      }).unwrap();

      if (response?.statusCode === 200) {
        showToast('Deleted successfully');
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
    }
  };

  const columns: GridColDef<any>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: 'email',
      headerName: 'Email',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return <p>{row?.email || '-'}</p>;
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setOpen(true);
                }}
              >
                <Delete
                  sx={{
                    color: 'red',
                    ':hover': {
                      color: 'white',
                    },
                  }}
                />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (isSuccess) {
      setCount(data?.data?.count);
    }
  }, [isSuccess]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1> Newsletter Email Users</h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Newsletter Email Users
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm('')}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
          </div>
        </Box>

        <div className="sorting_table">
          <TableComponent
            columns={columns}
            rows={data?.data?.data || []}
            count={count}
            page={page}
            onPageChange={onPageChange}
            loading={isLoading}
          />
        </div>

        <ConfirmationModal
          text={'Are you sure to delete this email?'}
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={() => {
            handleDelete();
          }}
        />
      </div>
    </MainContainer>
  );
};

export default NewsLetterEmail;
